import { render, staticRenderFns } from "./ContentChange.vue?vue&type=template&id=3a401014&scoped=true"
import script from "./ContentChange.vue?vue&type=script&lang=js"
export * from "./ContentChange.vue?vue&type=script&lang=js"
import style0 from "./ContentChange.vue?vue&type=style&index=0&id=3a401014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a401014",
  null
  
)

export default component.exports